import { render } from "./TrendingUpIcon.vue?vue&type=template&id=36665461"
import script from "./TrendingUpIcon.vue?vue&type=script&lang=js"
export * from "./TrendingUpIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__